import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { CommonConfig } from './common-config/common-config';
import { PageTitleComponent } from './page-title/page-title.component';
import { CommonModule } from '@angular/common';
import { PromoModalComponent } from './promo-modal/promo-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BaseCardComponent } from './base-card/base-card.component';
import { MatCardModule } from '@angular/material/card';
import { CurrencyFormatterPipe } from './pipes/currency-formatter.pipe';
import { CustomOnlyDateFormatterPipePipe } from './pipes/custom-only-date-formatter-pipe.pipe';
import { MatIconModule } from '@angular/material/icon';
import { SectionTitleComponent } from './section-title/section-title.component';
import { LoaderReportComponent } from './loader-report/loader-report.component';
import { MatButtonModule } from '@angular/material/button';
import { IsInViewportDirective, ScrollInViewportDirective } from './directives/is-in-viewport.directive';
import { MatDividerModule } from '@angular/material/divider';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { VideoRecorderOldComponent } from './video-recorder-old/video-recorder-old.component';
import { SwiperDirective } from './directives/swiper.directive';


@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    PageTitleComponent,
    PromoModalComponent,
    BaseCardComponent,
    CurrencyFormatterPipe,
    CustomOnlyDateFormatterPipePipe,
    SectionTitleComponent,
    LoaderReportComponent,
    IsInViewportDirective,
    ScrollInViewportDirective,
    StripHtmlPipe,
    SwiperDirective
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    PageTitleComponent,
    SectionTitleComponent,
    LoaderReportComponent,
    BaseCardComponent,
    CurrencyFormatterPipe,
    CustomOnlyDateFormatterPipePipe,
    IsInViewportDirective,
    ScrollInViewportDirective,
    StripHtmlPipe
  ],
  providers: [
    MenuItems,
    TranslateService]
})
export class SharedModule { }
